<div class="forgot-container">
  <div class="logo-container">
    <img src="assets/img/logo-projecao-profissional.svg" alt="Logo Projeção Profissional" class="forgot-logo" />
  </div>
  <h1 class="forgot-title">Redefinir Senha</h1>
  <p class="forgot-subtitle">Escolha uma nova senha para acessar sua conta.</p>

  <form [formGroup]="resetForm" (ngSubmit)="resetPassword()" *ngIf="resetForm">
    <mat-form-field appearance="outline" class="email-field">
      <mat-label>Nova senha</mat-label>
      <input
        matInput
        [type]="isNewPasswordVisible ? 'text' : 'password'"
        formControlName="newPassword"
        autocomplete="new-password"
      />
      <button mat-icon-button matSuffix type="button" (click)="toggleNewPasswordVisibility()">
        <mat-icon>{{ isNewPasswordVisible ? "visibility" : "visibility_off" }}</mat-icon>
      </button>
      <mat-error *ngIf="resetForm.get('newPassword')?.hasError('required')"> Nova senha é obrigatória </mat-error>
      <mat-error *ngIf="resetForm.get('newPassword')?.hasError('minlength')">
        A senha deve ter no mínimo 6 caracteres
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="email-field">
      <mat-label>Repita a nova senha</mat-label>
      <input
        matInput
        [type]="isConfirmPasswordVisible ? 'text' : 'password'"
        formControlName="confirmPassword"
        autocomplete="new-password"
      />
      <button mat-icon-button matSuffix type="button" (click)="toggleConfirmPasswordVisibility()">
        <mat-icon>{{ isConfirmPasswordVisible ? "visibility" : "visibility_off" }}</mat-icon>
      </button>
      <mat-error *ngIf="resetForm.get('confirmPassword')?.hasError('required')"> Confirmação é obrigatória </mat-error>
    </mat-form-field>

    <div *ngIf="resetForm.hasError('passwordMismatch') && resetForm.get('confirmPassword')?.touched" class="error">
      As senhas não coincidem
    </div>

    <button
      mat-raised-button
      color="primary"
      type="submit"
      [disabled]="resetForm.invalid || isLoading"
      class="forgot-submit-button"
    >
      <mat-spinner *ngIf="isLoading" diameter="20" class="button-spinner"></mat-spinner>
      <span *ngIf="!isLoading">Redefinir Senha</span>
      <span *ngIf="isLoading">Salvando...</span>
    </button>
  </form>

  <a routerLink="/sign-in" class="back-to-login">Voltar para Login</a>
</div>
